import { render, staticRenderFns } from "./medicion-ausentismo-otras.vue?vue&type=template&id=048da96a&scoped=true&"
import script from "./medicion-ausentismo-otras.vue?vue&type=script&lang=js&"
export * from "./medicion-ausentismo-otras.vue?vue&type=script&lang=js&"
import style0 from "./medicion-ausentismo-otras.vue?vue&type=style&index=0&id=048da96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048da96a",
  null
  
)

export default component.exports